<template>
  <div class="personal-data">
    <div class="wrapper">
      <div class="wrapList">
        <div class="item acea-row row-between-wrapper on">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue" v-if="isEdit">
              <VueCoreImageUpload
                class="btn btn-primary"
                :crop="false"
                compress="80"
                @imageuploaded="imageuploaded"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
                ref="upImg"
              >
                <div class="pictrue">
                  <img :src="user.avatar" />
                </div>
              </VueCoreImageUpload>
              <img src="@assets/images/alter.png" class="alter" />
            </div>
            <div class="pictrue" v-else>
              <div class="pictrue">
                <img :src="user.avatar" />
              </div>
            </div>
            <div class="text">
              <div class="name line1">{{ user.realName }}</div>
              <div class="phone">绑定手机号：{{ user.phone }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="headline">
      <div class="item acea-row row-between-wrapper">个人信息</div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>姓名</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.realName" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>昵称</div>
        <div class="input">
          <input
            type="text"
            v-model="user.nickname"
            :disabled="!isEdit"
            class="id"
          /><span class="iconfont icon-suozi" v-if="!isEdit"></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>性别</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.sex" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>生日</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.birthday" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>

      <div class="item acea-row row-between-wrapper">
        <div>账户名</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.username" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="user.corpName">
        <div>企业名称</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.corpName" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="user.jobName">
        <div>岗位</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.jobName" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="user.deptName">
        <div>部门</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.deptName" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="user.hiredate">
        <div>入职时间</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.hiredate" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>邮箱</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.mailbox" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>手机号</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.phone" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="user.cardTypeName">
        <div>证件类型</div>
        <div class="input acea-row row-between-wrapper">
          <input
            type="text"
            :value="user.cardTypeName"
            disabled
            class="id"
          /><span class="iconfont icon-suozi"></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="user.cardId">
        <div>证件号</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="user.cardId" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
    </div>
    <div class="modifyBnt cart-color" @click="isEdit = true" v-if="!isEdit">
      点击修改
    </div>
    <span v-else>
      <div class="modifyBnt bg-color-red" @click="submit">保存修改</div>
      <div class="modifyBnt2 cart-color" @click="isEdit = false">取消修改</div>
    </span>
    <div class="logOut cart-color acea-row row-center-wrapper" @click="logout">
      退出登录
    </div>
    <div
      class="clear clear-color acea-row row-center-wrapper"
      @click="clearWechat"
      v-if="isWeixin"
    >
      清除微信授权
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { trim, VUE_APP_API_URL, isWeixinOfO } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { getUserInfo, postUserEdit, getLogout, getUser } from "@api/user";
import { clearWechat } from "@api/public";
import { clearAuthStatus } from "@libs/wechat";

export default {
  name: "PersonalData",
  components: {
    VueCoreImageUpload
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/image/upload`,
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token
      },
      isWeixin: false,
      currentAccounts: 0,
      userIndex: 0,
      isEdit: false,
      user: {}
    };
  },
  mounted: function() {
    this.User();
    this.isWeixin = isWeixinOfO();
  },
  methods: {
    imageuploaded(res) {
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      if (this.user === undefined) return;
      this.$set(this.user, "avatar", res.link);
    },
    User: function() {
      let that = this;
      getUserInfo(2).then(res => {
        that.user = res.data;
      });
    },
    submit: function() {
      let userInfo = this.user;
      postUserEdit({
        nickname: trim(userInfo.nickname),
        avatar: userInfo.avatar
      }).then(
        res => {
          this.$store.dispatch("USERINFO", true);
          this.$dialog.success(res.msg);
          // this.$router.go(-1);
          this.isEdit = false;
        },
        error => {
          this.$dialog.error(error.msg);
        }
      );
    },
    logout: function() {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          getLogout()
            .then(res => {
              this.$store.commit("LOGOUT");
              clearAuthStatus();
              // location.href = location.origin;
              location.replace("/login");
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    clearWechat: function() {
      this.$dialog.confirm({
        mes: "确认清除微信授权吗?",
        opts: () => {
          clearWechat()
            .then(res => {
              this.$dialog.success("清除成功");
            })
            .catch(err => {
              this.$dialog.error("清除失败,请重试");
            });
        }
      });
    }
  }
};
</script>
